import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const TimeToHireTrendChart = ({ data, description }) => {
  // Data preparation for chart
  const timeToHireTrendsData = () => {
    const quarterData = {};
    
    data
      .filter(candidate => 
        candidate.stage === 'Hired' && 
        candidate.timeToHire && 
        candidate.quarter &&
        candidate.timeToHire > 0 // Ensure positive values only
      )
      .forEach(candidate => {
        if (!quarterData[candidate.quarter]) {
          quarterData[candidate.quarter] = {
            totalDays: 0,
            count: 0
          };
        }
        // Parse timeToHire as number and ensure it's positive
        const timeToHireValue = parseInt(candidate.timeToHire) || 0;
        if (timeToHireValue > 0) {
          quarterData[candidate.quarter].totalDays += timeToHireValue;
        }
        quarterData[candidate.quarter].count++;
      });
    
    return Object.entries(quarterData)
      .map(([quarter, data]) => ({
        name: quarter,
        days: Math.round(data.totalDays / data.count)
      }))
      .sort((a, b) => {
        // Sort by year then quarter
        const [aQ, aY] = a.name.split(' ');
        const [bQ, bY] = b.name.split(' ');
        return aY === bY ? aQ.localeCompare(bQ) : aY.localeCompare(bY);
      });
  };

  return (
    <div className="dashboard-card p-6 slide-in-up" style={{animationDelay: '1300ms'}}>
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-lg font-semibold text-gray-800">Time-to-Hire Trends by Quarter</h3>
        <div className="bg-teal-100 text-teal-800 text-xs font-medium px-2.5 py-1 rounded-full">
          Efficiency Trend
        </div>
      </div>
      {description && (
        <p className="text-sm text-gray-600 mb-4">{description}</p>
      )}
      <ResponsiveContainer width="100%" height={250}>
        <LineChart 
          data={timeToHireTrendsData()} 
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis 
            dataKey="name" 
            tickLine={false} 
            axisLine={false} 
            style={{ fontSize: '12px' }} 
          />
          <YAxis 
            tickLine={false} 
            axisLine={false} 
            style={{ fontSize: '12px' }} 
          />
          <Tooltip 
            contentStyle={{ 
              borderRadius: '8px', 
              border: 'none', 
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
              fontSize: '12px'
            }}
            formatter={(value) => [`${value} days`, 'Average Time']}
          />
          <Legend 
            iconType="circle" 
            iconSize={8} 
            align="right" 
            verticalAlign="top" 
            wrapperStyle={{ paddingBottom: '10px' }} 
          />
          <Line 
            type="monotone" 
            dataKey="days" 
            stroke="#0d9488" 
            activeDot={{ r: 8 }} 
            name="Average Days" 
            strokeWidth={2}
            dot={{ stroke: '#0d9488', strokeWidth: 2, r: 4, fill: 'white' }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TimeToHireTrendChart;
